import vue from 'vue';
const axios = require('axios');
import qs from 'qs';
import { PROXY_URL } from '../config/env';
import md5 from 'js-md5';
import { GenerateBrowserFingerprint } from '@/util/init';

let mid = GenerateBrowserFingerprint();
axios.defaults.headers.common['mid'] = mid;

/*
 * ---------------- 首页配置 ---------------
 * */

/*
 * 图形验证码安全校验
 */

export const getQueryCode = data => axios.get(PROXY_URL.user + '/reg/captcha/getUrl');
/*
 * 校验手机号是否有注册
 */
export const getPhoneExist = data => axios.get(PROXY_URL.user + '/reg/isPhoneExist', { params: data });

//判断能否助力
export const getIsCanAssist = data => axios.get(PROXY_URL.service + '/anon/assist/isCanAssist', { params: data });

// 帮助好友助力
export const getAddAssistor = data => axios.get(PROXY_URL.service + '/anon/assist/addAssistor', { params: data });

export const getModDataByModId = data =>
	axios.get(PROXY_URL.config + '/xubei-page-cloud/anon/cms/getModDataByModId', {
		params: data
	});

//获取商品详情接口
// export const queryGoodDetail = (data) => axios.post(PROXY_URL.config + '/b/goods/goodsDetail',qs.stringify(data));
export const queryGoodDetail = data =>
	axios.get(PROXY_URL.config + '/xubei-goods-cloud/anonapi/unifiedGoodsDetail', { params: data });

export const getGameList = data => axios.post('//rest-api.xubei.com/appxb/appconfig/rentPage', qs.stringify(data));

export const listCouponByConfig = (data, token) =>
	axios.get(PROXY_URL.userServer + '/couponConfig/anon/listCouponByConfig', {
		params: data,
		headers: {
			Authorization: token
		}
	});

export const getCouponByCenter = (data, token) =>
	axios.post(PROXY_URL.userServer + '/buyer/getCouponByCenter', qs.stringify(data), {
		headers: {
			Authorization: token
		}
	});

export const queryLowestGrade = () => axios.get(PROXY_URL.userServer + '/memberGrade/anon/queryLowestGrade');

export const listRegisterCouponByNew = (data, token) =>
	axios.get(PROXY_URL.userServer + '/memberBenefit/listRegisterCouponByNew', {
		params: data,
		headers: {
			Authorization: token
		}
	});

export const listRentShop = () => axios.post(PROXY_URL.config + '/xubei-seller-cloud/anon/listRentShop', {});

export const rentMerchant = (data, token) =>
	axios.get(PROXY_URL.userServer + '/rentMerchant/detail', {
		params: data,
		headers: {
			Authorization: token
		}
	});

export const isApplyByUser = token =>
	axios.get(PROXY_URL.userServer + '/rentMerchant/getUserApplyStatus', {
		headers: {
			Authorization: token
		}
	});

export const listMainGame4Rent = (data, token) =>
	axios.get(PROXY_URL.userServer + '/myShop/listMainGame4Rent', {
		headers: {
			Authorization: token
		}
	});

// 2021新年充值活动接口
export const getPrizeTime = (data, token) =>
	axios.get(PROXY_URL.userServer + '/redenvelope/prize/anon/carnival/getConfig', {
		headers: {
			Authorization: token
		}
	});

// 领取记录接口
export const listReceive = (data, token) =>
	axios.get(PROXY_URL.userServer + '/redenvelope/prize/anon/carnival/listReceive', {
		headers: {
			Authorization: token
		}
	});

// 充值抽奖状态查询
export const listLottery = (data, token) =>
	axios.get(PROXY_URL.userServer + '/redenvelope/prize/anon/carnival/recharge/listLottery', {
		headers: {
			Authorization: token
		}
	});

// 立即抽奖
export const lottery = (data, token) =>
	axios.get(PROXY_URL.userServer + '/redenvelope/prize/carnival/recharge/lottery', {
		params: data,
		headers: {
			Authorization: token
		}
	});

// 连续下单奖励查询
export const listPrize = (data, token) =>
	axios.get(PROXY_URL.userServer + '/redenvelope/prize/anon/carnival/order/listPrize', {
		headers: {
			Authorization: token
		}
	});

// 领取连续下单奖励
export const getPrize = (data, token) =>
	axios.get(PROXY_URL.userServer + '/redenvelope/prize/carnival/order/get', {
		params: data,
		headers: {
			Authorization: token
		}
	});

// 查询累计消费
export const getConsumeStatus = (data, token) =>
	axios.get(PROXY_URL.userServer + '/redenvelope/prize/anon/carnival/consume/status', {
		headers: {
			Authorization: token
		}
	});

// 领取累计消费
export const getConsume = (data, token) =>
	axios.get(PROXY_URL.userServer + '/redenvelope/prize/carnival/consume/get', {
		headers: {
			Authorization: token
		}
	});

// 领取累计消费
export const clickRecharge = (data, token) =>
	axios.get(PROXY_URL.userServer + '/activityUserPoint/clickRecharge', {
		headers: {
			Authorization: token
		}
	});

// 获取推广活动配置
export const getActivInfo = (data, token) => axios.get(PROXY_URL.userServer + '/promotionActiv/anon/getActivInfo');

// 获取推广用户信息
export const getInitiatorInfo = (data, token) =>
	axios.get(PROXY_URL.userServer + '/promotionActiv/getInitiatorInfo', {
		headers: {
			Authorization: token
		}
	});

// 佣金奖励列表
export const getSettleList = (data, token) =>
	axios.get(PROXY_URL.userServer + '/promotionActiv/getSettleList', {
		headers: {
			Authorization: token
		}
	});

// 佣金奖励列表
export const getPrizeDetailList = (data, token) =>
	axios.get(PROXY_URL.userServer + '/promotionPrize/getPrizeDetailList', {
		headers: {
			Authorization: token
		}
	});

// http://user-server.xubei-test.com/promotionPrize/getMyCoin
// 我的硬币
export const getMyCoin = (data, token) =>
	axios.get(PROXY_URL.userServer + '/promotionPrize/getMyCoin', {
		headers: {
			Authorization: token
		}
	});

// 用户排名
export const getCoinRankingAndPrize = (data, token) =>
	axios.get(PROXY_URL.userServer + '/promotionPrize/getCoinRankingAndPrize', {
		headers: {
			Authorization: token
		}
	});

// 领取硬币
export const receiveCoin = (data, token) =>
	axios.post(PROXY_URL.userServer + '/promotionPrize/receiveCoin', qs.stringify(data), {
		headers: {
			Authorization: token
		}
	});

// 用户领取排名奖品
export const receiveRankingPrize = (data, token) =>
	axios.post(PROXY_URL.userServer + '/promotionPrize/receiveRankingPrize', qs.stringify(data), {
		headers: {
			Authorization: token
		}
	});

// 实名认证 realName idNo
export const authentication = (data, token) =>
	axios.get(PROXY_URL.userServer + '/acctSafe/identityAuth', {
		params: data,
		headers: {
			Authorization: token
		}
	});

// 绑定支付宝 realName idNo
export const saveAlipayAccount = (data, token) =>
	axios.get(PROXY_URL.userServer + '/acctSafe/saveAlipayAccount', {
		params: data,
		headers: {
			Authorization: token
		}
	});

// 获取验证码
export const getCode = data =>
	axios.get(PROXY_URL.service + `/anon/captcha/anon/captcha/getUrl?clientType=1&businessId=${data.businessId}`);

// 发送图形验证码
export const sendMobileCode = data =>
	axios.get(
		PROXY_URL.service +
			'/anon/sms/sendCode?mobile=' +
			data.mobile +
			'&businessNo=' +
			data.businessNo +
			'&ticket=' +
			data.ticket +
			'&businessId=' +
			data.businessId
	);
//获取SVIP周卡信息
export const getSvipWeekCardInfoStore = (data, token) =>
	axios.get(PROXY_URL.userServer + '/user/member/svip/v2/getWeekSvipPrices', {
		params: data,
		headers: {
			Authorization: token
		}
	});

// 创建SVIP会员周卡订单 - 返2元活动专用
export const SvipV2Store = (data, token) =>
	axios.post(PROXY_URL.userServer + '/user/member/svip/v2/save', qs.stringify(data), {
		headers: {
			Authorization: token
		}
	});

// 创建充值订单 { rechargeAmt, rechargeType }
export const createFundRechargeStore = (data, token) =>
	axios.get(PROXY_URL.userServer + '/fund/recharge', {
		params: data,
		headers: {
			Authorization: token
		}
	});

// 轮询充值结果
export const getTopupDetailStore = (data, token) =>
	axios.get(PROXY_URL.userServer + '/pay/getTopupDetail', {
		params: data,
		headers: {
			Authorization: token
		}
	});

// 支付
export const PayBalanceStore = (data, token) =>
	axios.post(PROXY_URL.userServer + '/pay/balancePayNew', qs.stringify(data), {
		headers: {
			Authorization: token
		}
	});

// 贝壳抽奖获取用户信息
export const GetAwardUserInfo = token =>
	axios.get(PROXY_URL.userServer + `/market/getUserInfo`, {
		headers: {
			Authorization: token
		}
	});

// 兑换奖励跑马灯
export const GetLamps = (data, token) =>
	axios.get(PROXY_URL.userServer + `/market/getLamps`, {
		params: data,
		headers: {
			Authorization: token
		}
	});

// 获取兑换奖池列表 奖池类型 1 限时兑 2 随心兑
export const GetExchangeList = (data, token) =>
	axios.get(PROXY_URL.userServer + `/market/anon/getExchangeList`, {
		params: data,
		headers: {
			Authorization: token
		}
	});

// 获取兑换奖池-奖励列表 jackpotId   奖池ID（奖池列表接口返回）
export const GetRewardList = (data, token) =>
	axios.get(PROXY_URL.userServer + `/market/anon/getRewardList`, {
		params: data,
		headers: {
			Authorization: token
		}
	});

// 抽奖奖励跑马灯
export const GetDrawLamps = token =>
	axios.get(PROXY_URL.userServer + `/market/getDrawLamps`, {
		headers: {
			Authorization: token
		}
	});

// 获取抽奖-奖励列表
export const GetDrawList = token =>
	axios.get(PROXY_URL.userServer + `/market/anon/getDrawList`, {
		headers: {
			Authorization: token
		}
	});

/**
  *兑换奖品
  *  @param {*} params {
    BigDecimal 订单金额
    bakerNum 贝壳数量
    rewardId 奖励ID
    num 兑换数量
  }
   * @returns
*/
export const ConvertReward = (data, token) =>
	axios.post(
		PROXY_URL.userServer + `/market/convertReward`,
		{ ...data },
		{
			headers: {
				'Content-Type': 'application/json',
				Authorization: token
			}
		}
	);

/**
  *上报实物奖励信息
  *  @param {*} params {
  gameAccount 领取账号
  gamePwd 游戏密码
  gameServer 游戏区服
  type 类型 1 兑换 2 抽奖
  rewardId 奖品ID
  orderNo "兑换订单号"（兑换实物奖励必填，抽奖实物奖励无）
  }
   * @returns
*/
export const AppearMatter = (data, token) =>
	axios.post(
		PROXY_URL.userServer + `/market/appearMatter`,
		{ ...data },
		{
			headers: {
				'Content-Type': 'application/json',
				Authorization: token
			}
		}
	);

// 获取兑换记录 pageIndex   pageSize
export const GetExchangeOrder = (data, token) =>
	axios.get(PROXY_URL.userServer + `/market/getExchangeOrder`, {
		params: data,
		headers: {
			Authorization: token
		}
	});

// 获取兑换记录 pageIndex   pageSize
export const GetDrawLog = (data, token) =>
	axios.get(PROXY_URL.userServer + `/market/getDrawLog`, {
		params: data,
		headers: {
			Authorization: token
		}
	});

// 获取上报的实物信息
export const GetMatterInfo = (data, token) =>
	axios.get(PROXY_URL.userServer + `/market/getMatterInfo`, {
		params: data,
		headers: {
			Authorization: token
		}
	});

// 抽奖
export const getDrawStore = (data, token) =>
	axios.get(PROXY_URL.userServer + `/market/draw`, {
		params: data,
		headers: {
			Authorization: token
		}
	});

// 拓展任务列表
export const GetTaskList = token =>
	axios.get(PROXY_URL.userServer + `/marketTask/getTaskList`, {
		headers: {
			Authorization: token
		}
	});

// 领取拓展任务奖励
export const ReceiveLotteryNum = (data, token) =>
	axios.get(PROXY_URL.userServer + `/marketTask/get/lottery`, {
		params: data,
		headers: {
			Authorization: token
		}
	});

// 抽奖-发放奖品
export const getMarketGrant = (data, token) =>
	axios.get(PROXY_URL.userServer + `/market/grant`, {
		params: data,
		headers: {
			Authorization: token
		}
	});

// 抽奖-发放奖品
export const GetConSumptionStore = token =>
	axios.get(PROXY_URL.userServer + `/marketTask/accumulative/consumption`, {
		headers: {
			Authorization: token
		}
	});

// 领取累计消费任务抽奖次数
export const GetConsumeTaskReceivingCountStore = token =>
	axios.get(PROXY_URL.userServer + `/marketTask/getConsumeTaskReceivingCount`, {
		headers: {
			Authorization: token
		}
	});

// 领取日消费任务抽奖次数
export const GetreceiveDayConsumeStore = (data, token) =>
	axios.get(PROXY_URL.userServer + `/marketTask/receiveDayConsume`, {
		params: data,
		headers: {
			Authorization: token
		}
	});

// 复制链接时上报
export const GogoVip = token =>
	axios.get(PROXY_URL.userServer + `/marketTask/copy/gogoVip`, {
		headers: {
			Authorization: token
		}
	});

// 获取会员列表
export const GetMemberList = (data, token) =>
	axios.get(PROXY_URL.userServer + `/user/member/svip/anon/getPrices/new`, {
		params: data,
		headers: {
			Authorization: token
		}
	});

// 获取用户信息
export const GetUserInfo = token =>
	axios.get(PROXY_URL.userServer + `/acctManage/simple/index`, {
		headers: {
			Authorization: token
		}
	});

// 创建SVIP会员订单
export const CreateSvipOrder = (data, token) =>
	axios.post(PROXY_URL.userServer + '/user/member/svip/v2/save', qs.stringify(data), {
		headers: {
			Authorization: token
		}
	});

// 获取客服链接
export const GetCustomerSystemUrl = (data, token) =>
	axios.get(PROXY_URL.userServer + '/serviceSkip/anon/getSkipByChannel', {
		headers: { token },
		params: data
	});

// 实名认证
export const IdentityAuth = (data, token) =>
	axios.get(PROXY_URL.userServer + '/acctSafe/identityAuth', {
		params: data,
		headers: { Authorization: token }
	});

// 获取青少年模式弹窗
export const GetShowStatus = (data, token) =>
	axios.get(PROXY_URL.userServer + '/user/teenagerConfig/anon/getShowStatus', {
		params: data,
		headers: {
			Authorization: token
		}
	});

// 限时兑换-设置提醒
export const SetUpStore = token =>
	axios.get(PROXY_URL.userServer + '/market/setUp', {
		headers: {
			Authorization: token
		}
	});

// 解除青少年模式
export const CloseTeenager = (data, token) =>
	axios.get(PROXY_URL.userServer + '/user/teenagerConfig/closeTeenager', {
		params: data,
		headers: {
			Authorization: token
		}
	});

// 其他事件埋点
export const SetPoint = (data, token) =>
	axios.get(PROXY_URL.userServer + '/marketBuriedEvent/point', {
		params: data,
		headers: {
			Authorization: token
		}
	});

// 个人信息投诉发送邮件
export const ComplaintStore = data => axios.post(PROXY_URL.userServer + '/complaint/anon/send', data);
// 获取滑块验证码
export const GetGetInfo = data => axios.get(`${PROXY_URL.service}/anon/captcha/v3/getInfo`, { params: data });

// 获取验证码 sendCodeV3
export const GetSendCodeV3 = data =>
	axios.get(`${PROXY_URL.service}/anon/sms/sendCodeV3`, {
		params: data
	});

//胖乖登录/sms/user/login
export const pangguaiLogin = data =>
	axios.get(`${PROXY_URL.user}/sms/user/login`, {
		params: data
	});
// 虚拟渠道转实际渠道 /anon/virtualChannel/queryBindChannel
export const QueryBindChannelStore = data =>
	axios.get(`${PROXY_URL.userServer}/anon/virtualChannel/queryBindChannel`, {
		params: data
	});
// 获取验证码 sendCodeV4
export const GetSendCodeV4 = data =>
	axios.get(`${PROXY_URL.service}/anon/sms/sendCodeV4`, {
		params: data
	});

// 获取验证码 sendCodeV4
export const GetShowVerification = data =>
	axios.get(`${PROXY_URL.service}/anon/sms/showVerification`, {
		params: data
	});

/**
  *校验openid
  *  @param {*} params {
  * openId  openid
  * businessNo  渠道号
  }
   * @returns
*/
export const CheckOpenId = data => axios.post(`${PROXY_URL.user}/weixin/weekGrant/checkOpenId`, qs.stringify(data));

/**
  *绑定openid
  *  @param {*} params {
  * phone  手机号
  * code  验证码
  * openId  openid
  * businessNo  渠道号
  }
   * @returns
*/
export const BindOpenIdByPhone = data =>
	axios.post(`${PROXY_URL.user}/weixin/weekGrant/bindOpenIdByPhone`, qs.stringify(data));

/**
  *获取平台券
  }
   * @returns
*/
export const GetPlatformCoupon = token =>
	axios.get(`${PROXY_URL.userServer}/activity/gzh/anon/activList`, {
		headers: {
			Authorization: token
		}
	});

// 获取店铺游戏列表
export const GetShopMainGameList = () => axios.get(`${PROXY_URL.userServer}/activity/gzh/anon/shopMainGameList`);

/**
  *根据gameId获取店铺券
  *  @param {*} params {
  * gameId  游戏id 为空就是全部
  }
   * @returns
*/
export const GetShopCouponList = (data, token) =>
	axios.get(`${PROXY_URL.userServer}/activity/gzh/anon/shopList?gameId=${data}`, {
		headers: {
			Authorization: token
		}
	});

/**
  *领取优惠券
  *  @param {*} params {
  * couponId  优惠券id
  * id  店铺id或者活动id
  * type  1：平台、3：店铺
  }
   * @returns
*/
export const ReceiveCoupon = (data, token) =>
	axios.get(`${PROXY_URL.userServer}/activity/gzh/receiveCoupon`, {
		params: data,
		headers: {
			Authorization: token
		}
	});

/**
  *微信公众号抢券
  *  @param {*} params {
  * positionId : 20, // 微信公众号抢券 首页
  * eventType : 3  //  3."周末券"微信公众号
  }
   * @returns
*/
export const CouponBuriedPoint = (data, token) =>
	axios.post(
		PROXY_URL.userServer + '/user/behavior/point/anon/save',
		qs.stringify({ positionId: 20, eventType: 3, ...data }),
		{
			headers: {
				appChannel: data.channel,
				Authorization: token
			}
		}
	);

/**
  * 埋点接口
  *  @param {*} params {
  * couponId  优惠券id
  * id  店铺id或者活动id
  * type  1：平台、3：店铺
  }
   * @returns
*/
export const BuriedPointStore = data =>
	axios.post(`${PROXY_URL.tracking}/eventReporting`, qs.stringify({ jsonData: JSON.stringify(data) }), {
		headers: { ts: data.ts, sign: md5('XUBEIEVENT' + data.ts) }
	});

/**
 * 获取配置的活动信息
 */
export const GetConfigInfoStore = token =>
	axios.get(`${PROXY_URL.userServer}/market/configInfo`, {
		headers: {
			Authorization: token
		}
	});

/**
 * 获取抽奖奖池概率
 */
export const GetDrawRateStore = token =>
	axios.get(`${PROXY_URL.userServer}/market/drawRate`, {
		headers: {
			Authorization: token
		}
	});

/**
 * 浏览贝壳活动送签到积分
 */
export const BrowseMarketStore = (data, token) =>
	axios.get(`${PROXY_URL.userServer}/user/integral/browseMarket`, {
		params: data,
		headers: {
			Authorization: token
		}
	});

/**
 * 日常消费任务一键领取
 */
export const GetClaimDayConsumeStore = token =>
	axios.get(`${PROXY_URL.userServer}/marketTask/claimDayConsume`, {
		headers: {
			Authorization: token
		}
	});

/**
 * 获取往期中间名单
 */
export const GetHistoryWinnerStore = (data, token) =>
	axios.get(`${PROXY_URL.userServer}/market/historyWinner`, {
		params: data,
		headers: {
			Authorization: token
		}
	});

/**
 * 贝壳活动新埋点上报
 */
export const GetPointV2Store = (data, token) =>
	axios.get(`${PROXY_URL.userServer}/marketBuriedEvent/pointV2`, {
		params: data,
		headers: {
			appChannel: data.channel,
			Authorization: token
		}
	});

/**
 * 获取企业微信入口配置
 * @param {*} entryType 入口类型 1.安卓-收藏 2.安卓-svip 3.安卓-订单列表 4.安卓-push 5.安卓-签到； 21.ios-收藏 22.ios-svip 23.ios-订单列表 24.ios-push 25.ios-签到； 31.uni-收藏 33.uni-订单列表 46.云更新-支付完成 47.云更新-客户端上号
 */
export const GetEntryConfigStore = (data, token) =>
	axios.get(`${PROXY_URL.userServer}/enterprise/weixin/anon/getEntryConfig`, {
		params: data,
		headers: {
			Authorization: token
		}
	});

/**
 * 用户点击哪些svip属性
 */
export const GetReadSvipAttrStore = (data, token) =>
	axios.get(`${PROXY_URL.userServer}/user/member/svip/v2/readSvipAttr`, {
		params: data,
		headers: {
			appChannel: data.channel,
			Authorization: token
		}
	});

/**
 * 用户点击哪些svip属性
 */
export const ClickSvipAttrStore = (data, token) =>
	axios.get(`${PROXY_URL.userServer}/user/member/svip/v2/clickSvipAttr`, {
		params: data,
		headers: {
			appChannel: data.channel,
			Authorization: token
		}
	});

/**
 * 企微抽奖 奖品列表
 */
export const GetQwPrizeListStore = (params, token) =>
	axios.get(`${PROXY_URL.userServer}/enterprise/weixin/anon/getPrizeList`, {
		params,
		headers: {
			Authorization: token
		}
	});

/**
 * 企微抽奖 抽奖接口
 */
export const GetQwLotteryStore = token =>
	axios.get(`${PROXY_URL.userServer}/enterprise/weixin/lottery`, {
		headers: {
			Authorization: token
		}
	});

/**
 * 企微抽奖 中奖记录
 */
export const GetQwDrawLogStore = () => axios.get(`${PROXY_URL.userServer}/enterprise/weixin/anon/getDrawLog`);

/**
 * 企微抽奖 周末券登录接口
 */
export const GetQwWxAppletLoginStore = data => axios.post(PROXY_URL.user + '/h5Week/login', qs.stringify(data));

/**
 * 企微抽奖 周末券登录接口
 */
export const GetReceiveCouponStore = (data, token) =>
	axios.post(PROXY_URL.userServer + '/enterprise/weixin/receiveCoupon', qs.stringify(data), {
		headers: {
			Authorization: token
		}
	});

/**
 * CPM推广上报
 */
export const RegistrationAddStore = (params, token) =>
	axios.get(`${PROXY_URL.userServer}/promotion/registration/add`, {
		params,
		headers: {
			Authorization: token
		}
	});

/**
 * 获取游戏和群聊信息
 */
export const GetAllGameAndGroupStore = params =>
	axios.get(`${PROXY_URL.userServer}/enterprise/guideGame/anon/getAllGameAndGroup`, {
		params
	});

/**
 * 套餐券推广说明商户粉丝数据
 */
export const GetSellerFanDataStore = (params, token) =>
	axios.get(`${PROXY_URL.userServer}/package/coupons/seller/getSellerFanData`, {
		params,
		headers: {
			Authorization: token
		}
	});

/**
 * 套餐券推广跑马灯数据
 */
export const GetRaceLampRemarkStore = params =>
	axios.get(`${PROXY_URL.userServer}/package/coupons/seller/anon/getRaceLampRemark`, {
		params
	});

// 获取一张h5优惠券coupon/buyer/getQwH5Coupon
export const getQwH5Coupon = params =>
	axios.get(`${PROXY_URL.userServer}/coupon/buyer/anon/getQwH5Coupon`, {
		params
	});

//领取优惠卷 /buyer/getCoupon
export const getCoupon = (data, token) =>
	axios.post(PROXY_URL.userServer + '/buyer/getCoupon', qs.stringify(data), {
		headers: {
			Authorization: token
		}
	});

// 获取用户所有等级规格信息
export const getSellerGradeSkuList = (token) =>
	axios.get(`${PROXY_URL.userServer}/seller/grade/getSellerGradeSkuList`, {
		headers: {
			Authorization: token
		}
	});	

// 获取用户所有等级权益信息
export const getSellerGradeAndPermissionForUser = (params, token) =>
	axios.get(`${PROXY_URL.userServer}/seller/grade/getSellerGradeAndPermissionForUser`, {
		params,
		headers: {
			Authorization: token
		}
	});	

// 获取所有等级UI资料信息
export const getGradeUiResList = (token) =>
	axios.get(`${PROXY_URL.userServer}/seller/grade/getGradeUiResList`, {
		headers: {
			Authorization: token
		}
	});	

// 获取当前用户卖家等级基础信息
export const getUserSellerGradeBasicInfo = (token) =>
	axios.get(`${PROXY_URL.userServer}/seller/grade/getUserSellerGradeBasicInfo`, {
		headers: {
			Authorization: token
		}
	});		

// 获取当前用户优惠券列表接口	
export const getUserCoupon = (params, token) =>
	axios.get(`${PROXY_URL.userServer}/buyer/myOrderCouponList`, {
		params,
		headers: {
			Authorization: token
		}
	});	

// 获取当前登录用户信息	
export const getUserInfo = (token) =>
	axios.get(`${PROXY_URL.userServer}/userInfo/index`, {
		headers: {
			Authorization: token
		}
	});	

// 获取钻石卖家游戏门槛接口
export const getDiamondSellerThresholdList = (token) =>
	axios.get(`${PROXY_URL.userServer}/seller/grade/getDiamondSellerThresholdList`, {
		headers: {
			Authorization: token
		}
	});		

export const getBenefitByUser = (token) =>
	axios.get(`${PROXY_URL.userServer}/user/member/svip/anon/getBenefitByUser`, {
		headers: {
			Authorization: token
		}
	})

// 获取steam热门游戏列表
export const getHotSteamGame = (params, token) =>
	axios.get(`${PROXY_URL.userServer}/client/steam/anon/hotSteamGame`, {
		params,
		headers: {
			Authorization: token
		}
	});

// 提交助力 friendSupport
export const friendSupport = (params, token) =>
	axios.get(`${PROXY_URL.userServer}/steam/tryPlay/friendSupport`, {
		params,
		headers: {
			Authorization: token
		}
	});


// WEBPACK FOOTER //
// ./src/service/getData.js